<template>
  <div>
    <div class="inline-flex pb-6">
      <h1 class="inline-flex pr-4">
        FDMS Inbound Service Component
        <p class="pl-4">|</p>
      </h1>
      <p class="pr-4"></p>
      <vs-button color="#5b3cc4" type="filled" icon="search" @click="regrid"
        >List</vs-button
      >

      <p class="pr-4"></p>
      <vs-dropdown>
        <vs-button
          class="btn-drop"
          type="filled"
          icon="more_horiz"
          color="success"
          v-if="btndis"
          >Action</vs-button
        >
        <vs-dropdown-menu>
          <vs-dropdown-item @click="goPutselect"
            >MTO Confirm In</vs-dropdown-item
          >
        </vs-dropdown-menu>
      </vs-dropdown>
      <p class="pr-4"></p>
    </div>

    <transition-group
      enter-active-class="animated lightSpeedIn"
      leave-active-class="animated lightSpeedOut"
    >
      <inbdadd
        v-if="addshow"
        :key="addshow"
        :acstate="acstate"
        :cmansNumber="cmansNumber"
        :recid="recid"
        @grid="grid"
      ></inbdadd>
      <cmanview
        v-if="viewshow"
        :key="viewshow"
        :acstate="acstate"
        :cmansNumber="cmansNumber"
        :recid="recid"
        @grid="grid"
      ></cmanview>
      <aggrid
        v-if="gridshow"
        :key="gridshow"
        :masrec="masrec"
        @recsel="recsel"
        @mousedown.middle.native="getXY"
      ></aggrid>
      <inberror v-if="errorshow" :key="errorshow" :errdata="errdata"></inberror>
    </transition-group>
  </div>
</template>

<script>
// import aggrid from "./DataTable/AgGrid";
import aggrid from "./grid.vue";
import inbdadd from "./cmansdetails_add";
import cmanview from "./cmansdetails_view.vue";
import inberror from "./inberror";
import moment from "moment";

import axios from "axios";
import {   BASE_API_URL,
  PROX_URL,
  NETBAY_URL } from "@/constants/index.ts";

export default {
  data() {
    return {
      skus_code: "",
      cmansNumber: this.$route.params.id,
      inbordersNumber: "",
      errdata: null,
      errorshow: false,
      addshow: false,
      gridshow: false,
      viewshow: false,
      btndis: false,
      comUpload: false,
      recid: "0",
      curX: null,
      curY: null,
      acstate: null,
      masrec: null,
      fabact: [
        { act: "cusAdd", label: "Add" },
        { act: "cusEdit", label: "Edit" },
        { act: "cusDel", label: "Delete" },
        { act: "goDetail", label: "Skus" },
        { act: "goPrint", label: "PrintQR" },
        { act: "goPutaway", label: "PutAway" },
        { act: "goPutselect", label: "PutAwaySelect" },
        { act: "hideFab", label: "Hide" },
      ],
    };
  },
  computed: {
    fabStyle: function () {
      return {
        left: this.curX + "px",
        top: this.curY + "px",
      };
    },
  },
  methods: {
    handle_function_call(function_name) {
      this[function_name]();
    },
    recsel(val, val2) {
      // alert(val2);
      this.btndis = true;
      this.inbordersNumber = val2;
      // console.log(this.recid);
      this.skus_code = val;
    },
    goDetail() {
      var rec = this.recid;
      var res = rec.split(",");
      // console.log(res.length);
      if (res.length != 1) {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Array Length Error",
          text: "Can't Select Multiple Record",
        });
      } else {
        this.btndis = true;
        localStorage.setItem("LS_Page", this.$route.path);
        this.$router.replace("/Skus/" + this.recid);
      }
    },
    // cusAdd() {
    //   this.recid = 0;
    //   this.addshow = true;
    //   this.gridshow = false;
    //   this.btndis = false;
    //   this.errorshow = false;
    //   this.acstate = "ADD";
    // },
    cusAdd() {
      this.addshow = false;
      this.viewshow = true;
      this.gridshow = false;
      this.btndis = false;
      this.errorshow = false;
      this.acstate = "VIEW";
    },
    grid() {
      this.addshow = false;
      this.viewshow = false;
      this.gridshow = true;
      this.btndis = false;
      this.errorshow = false;
      this.$store.dispatch("setReportGrid", 0);
    },
    goBack() {
      this.addshow = false;
      this.viewshow = false;
      this.gridshow = true;
      this.btndis = false;
      this.errorshow = false;
    },
    goBackMore() {
      // console.log(this.$route.path);
      this.lspage = localStorage.getItem("LS_Page");
      this.$router.replace(this.lspage);
    },
    goPrint() {
      var rec = this.recid;
      var res = rec.split(",");
      // console.log(res.length);
      if (res.length != 1) {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Array Length Error",
          text: "Can't Select Multiple Record",
        });
      } else {
        const formData = {
          token: localStorage.getItem("token"),
          token2: localStorage.getItem("token2"),
          dbname: localStorage.getItem("dbname"),
          skus_code: this.recid,
        };
        axios
          .post("/ApiInbdPreprint", formData)
          .then((res) => {
            if (res.data.status == "error") {
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Print Error",
                text: res.data.message,
                fixed: true,
              });
            } else {
              let url = localStorage.getItem("appdb");
              let dbname = localStorage.getItem("dbname");
              window.open(
                url + "api/ApiInbdetailsPrint/" + this.recid + "/" + dbname
              );
            }
          })
          .catch((err) => {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Deleted Error",
              text: err,
            });
          });
      }
    },
    regrid() {
      // this.$router.replace("/Inbdetails/0");
      this.masrec = "0";
      this.viewshow = false;
      this.gridshow = false;
      setTimeout(() => {
        this.grid();
      }, 1000);
    },
    cusEdit() {
      var rec = this.recid;
      var res = rec.split(",");
      // console.log(res.length);
      if (res.length != 1) {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Array Length Error",
          text: "Can't Edit Multiple Record",
        });
      } else {
        this.addshow = true;
        this.viewshow = false;
        this.gridshow = false;
        this.btndis = false;
        this.errorshow = false;
        this.acstate = "EDIT";
      }
    },
    cusDel() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Delete? " + this.recid,
        accept: this.acceptAlert,
      });
    },
    acceptAlert() {
      var rec = this.recid;
      var res = rec.split(",");
      // console.log(res.length);
      if (res.length != 1) {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Array Length Error",
          text: "Can't Edit Multiple Record",
        });
      } else {
        this.btndis = false;
        const formData = {
          token: localStorage.getItem("token"),
          token2: localStorage.getItem("token2"),
          dbname: localStorage.getItem("dbname"),
          number: this.recid,
        };
        axios
          .post("/ApiDelCmansDetails", formData)
          .then((res) => {
            if (res.data.status == "error") {
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Deleted Error",
                text: res.data.message,
                fixed: true,
              });
            } else {
              this.$store.dispatch("setReportGrid", 1);

              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "Deleted Complete",
                text: res.data.message,
              });
            }
          })
          .catch((err) => {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Deleted Error",
              text: err,
            });
          });
      }

      // this.gridshow = false;
      // this.gridshow = true;
    },
    getXY(event) {
      this.curX = event.clientX;
      this.curY = event.clientY;

      // console.log(this.curX);
      // console.log(this.curY);
    },
    goPutaway() {
      // console.log(this.recid);
      // var rec = this.recid;
      // var res = rec.split(",");
      // console.log(res.length);
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to PutAway All? ",
        accept: this.acceptPutaway,
      });
    },
    acceptPutaway() {
      var rec = this.recid;
      var res = rec.split(",");
      // console.log(res.length);
      if (res.length != 1) {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Array Length Error",
          text: "Can't Select Multiple Record",
        });
      } else {
        const formData = {
          token: localStorage.getItem("token"),
          token2: localStorage.getItem("token2"),
          dbname: localStorage.getItem("dbname"),
          itemcode: this.recid,
        };
        axios
          .post("/ApiSkuPrePutaways", formData)
          .then((res) => {
            if (res.data.status == "error") {
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "PutAway Error",
                text: res.data.message,
                fixed: true,
              });

              this.errdata = res.data.errdata;

              this.addshow = false;
              this.viewshow = false;
              this.gridshow = false;
              this.btndis = false;
              this.errorshow = true;
            } else {
              // let url = localStorage.getItem("appdb");
              // window.open(url + "api/ApiSkusPrint/" + this.recid);
              // console.log(res.data.message);
              this.$router.replace("/Putawaysdetails/" + res.data.putnumber);
            }
          })
          .catch((err) => {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Deleted Error",
              text: err,
            });
          });
      }
    },
    goPutselect() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to MTO Confirm In? ",
        accept: this.goPickAll,
      });
    },
    async goPickAll() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
      const NETBAY_TOKEN = localStorage.getItem("NETBAY_TOKEN");
      //  console.log(NETBAY_TOKEN);
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        const formData2 = {
          skus_code: this.skus_code,
        };

        const response2 = await axios.post(
          `${BASE_API_URL}/inbound-svc/inbound/getForConfirmIn`,
          formData2,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        if (response2.data.status != "success") {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from Submit to FDMS",
            text: response2.data.message,
            fixed: true,
          });
        } else {
          // console.log('netlogin');
          let confirmInDate = moment(response2.data.readyat).format("YYYYMMDD");
          let confirmInTime = moment(response2.data.readyat).format("HHmmssss");

          const formData3 = {
            transactionNo: this.inbordersNumber,
            confirmInDate: confirmInDate,
            confirmInTime: confirmInTime,
          };

          const response3 = await axios.post(
            PROX_URL + NETBAY_URL + `fz-webservice/api/zone3-confirm-in`,
            // `https://kongapi.aotga.com/proxy-svc/https://uataotdc.netbay.co.th/fz-webservice/api/zone3-otherport`,
            // `https://uataotdc.netbay.co.th/fz-webservice/api/zone3-otherport`,
            // `/api/fz-webservice/api/zone3-otherport`,
            formData3,

            {
              headers: {
                "Content-Type": "application/json",
                token: NETBAY_TOKEN,
              },
            }
          );

          if (response3.status == "fail") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error for FDMS",
              text: response3.message,
            });
          } else {
            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Submit Success",
              text: response3.data.message,
            });

            const moment = require("moment-timezone");
            const timezone = "Asia/Bangkok";
            const now = moment().tz(timezone);

            const formData = {
              number: this.inbordersNumber,
              code: response3.data.code,
              message: response3.data.message,
              createdAt: now,
            };

            await axios.post(
              `${BASE_API_URL}/inbound-svc/inbound/resFDMSMtoIn`,
              formData,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );
          }
        }
      } catch (error) {
        // alert("กรุณาเข้าระบบอีกครั้ง");
        if (error.response) {
          // console.log(error.response.data);
          // console.log(error.response.data.message);
          // console.log(error.response.status);
          // console.log(error.response.headers);
          if (error.response.data.message == "Token has expired.") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: error.response.data.message,
            });
          } else {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error for FDMS",
              text: error.response.data.message,
            });

            const moment = require("moment-timezone");
            const timezone = "Asia/Bangkok";
            const now = moment().tz(timezone);

            const formData = {
              number: this.inbordersNumber,
              code: error.response.data.code,
              message: error.response.data.message,
              createdAt: now,
            };

            await axios.post(
              `${BASE_API_URL}/inbound-svc/inbound/resFDMSMtoIn`,
              formData,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );
          }
        }
      }
    },
    hideFab() {
      this.btndis = false;
    },
  },
  components: {
    aggrid,
    inbdadd,
    inberror,
    cmanview,
  },
  created() {
    // console.log(this.inborders_number);
    this.masrec = this.cmansNumber;
    // console.log(this.masrec);
    if (this.masrec != 0) {
      this.grid();
    }
  },
};
</script>

<style scoped>
.fab-wrapper {
  position: fixed;
  left: 100px;
  top: 500px;
  z-index: 5;
  display: flex;
  flex-direction: center;
  align-items: center;
}
.fab {
  background-color: rgb(231, 55, 55);
}
</style>
